export function addToCart() {
  const buttons = document.querySelectorAll('.ajax_add_to_cart');
  const singleButtons = document.querySelectorAll('.single_add_to_cart_button');

  const observe = element => {
    const onChange = (mutationList, observer) => {
      mutationList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (element.classList.contains('added') && !element.classList.contains('timeout')) {
            element.classList.add('timeout');

            const originalText = element.innerHTML;
            element.innerHTML = "Tillagd";

            setTimeout(() => {
              element.innerHTML = originalText;
              element.classList.remove('timeout');
              element.classList.remove('added');
            }, 1000);
          }
        }
      })
    }
    
    const observer = new MutationObserver(onChange);
    observer.observe(element, {
      attributes: true
    })
  }

  buttons.forEach(button => observe(button));
  singleButtons.forEach(button => observe(button));
}